/**
 * 4 CTA types, mutually exclusive
 */
export enum CollectionCtaTypes {
  RESUME = 'Resume',
  SIGN_UP = 'Sign Up',
  FAVORITE = 'Favorite',
  FAVORITED = 'Favorited'
}
